<template>
  <div>
    <Dropdown>
      <template #button="{ open }">
        <BaseBadge silver class="focus:outline-none cursor-pointer" @click="open">
          <span class="uppercase">{{ status }}</span>
        </BaseBadge>
      </template>
      <template #default="{ close }">
        <ul class="menu">
          <li
            v-for="statusOption in statusOptions"
            :key="statusOption.value"
            class="menu__item text-sm leading-5 hover:bg-gray-200 py-2"
            @click="updateStatus(statusOption.value, close)"
          >
            {{ statusOption.label }}
          </li>
        </ul>
      </template>
    </Dropdown>
  </div>
</template>

<script>
export default {
  props: {
    projectId: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      statusOptions: [
        { value: 'draft', label: 'Draft' },
        { value: 'pending', label: 'Pending' },
        { value: 'in progress', label: 'In progress' },
        { value: 'in review', label: 'In review' },
        { value: 'completed', label: 'Completed' },
        { value: 'cancelled', label: 'Cancelled' },
      ],
    };
  },
  computed: {
    hasStatus() {
      return typeof this.status === 'string';
    },
  },
  methods: {
    async updateStatus(status, next) {
      try {
        await this.$store.dispatch('ui/projects/update', {
          projectUuid: this.projectId,
          formData: {
            status,
          },
        });
      } catch (error) {
        //
      } finally {
        next();
      }
    },
  },
};
</script>
